// @ts-nocheck
"use strict";
import Swiper from "swiper/bundle";

var productListSwipper = new Swiper(".more-product-list", {
    slidesPerView: "auto",
    spaceBetween: 10,
    resizeObserver: true,
});


window.pdpFullImageSlider = new Swiper(".js-product-full-view", {
    slidesPerView: "auto",
    zoom: true,
    observer: true,
    observeParents: true,
    spaceBetween: 0,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    , 
    on : {
        observerUpdate: function (swiperEl) {
            var selectedIndex = $('#productSliderModal').attr('data-current-slide') || 0; 
            swiperEl.slideTo(selectedIndex, 0 , false);
        }
    }

})
// var $container = $("#swipeContainer");
// var startY;

// $container.on("touchstart", handleTouchStart);
// $container.on("touchmove", handleTouchMove);

// function handleTouchStart(event) {
//     startY = event.touches[0].clientY;
//     console.log('startY ' + startY);
// }

// function handleTouchMove(event) {
//     var scrollPosition = $container.scrollTop();
//     if (event.touches.length > 1) return; // Ignore if multiple fingers are touching
//     // $container.addClass("full-height");
//     const touchY = event.touches[0].clientY;
//     const swipeDistance = startY - touchY;
//     console.log('swipeDistance ' + swipeDistance);
//     if (swipeDistance > 50) {
//         // Reveal additional content if swipe-up distance is greater than 50 pixels
//         $container.addClass("full-height");
//     } else if (swipeDistance < -50 && scrollPosition === 0) {
//         // debugger;
//         $container.removeClass("full-height");
//     }
//     // console.log(swipeDistance);
// }

var $productAccordion = $(".product-accordion .accordion");
$productAccordion.on("click", function () {
    $(this).toggleClass("active");
});
